
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { PanicModeHistory } from '@/interfaces/models/PanicModeHistory';
import VTable from '@/components/shared/table/VTable.vue';
import panicHeaders from './panicHeaders';

@Component({
  components: { VTable },
})
export default class VenuePanicTable extends Vue {
  @Prop({ type: Array, required: true }) public panicLogs!: PanicModeHistory[];

  public headers: ColumnHeader[] = panicHeaders;
  public itemsSorted: PanicModeHistory[] = this.panicLogs;

  public sortItems({ sortBy, sortOrder }: { sortBy: string; sortOrder: string }): void {
    const initial = [...this.itemsSorted];

    this.itemsSorted = initial.sort((a, b) => {
      const aValue = Date.parse((a as any)[sortBy]) || (a as any)[sortBy];
      const bValue = Date.parse((b as any)[sortBy]) || (b as any)[sortBy];

      if (aValue === bValue) {
        return 0;
      }

      if (sortOrder === 'asc') {
        return aValue < bValue ? -1 : 1;
      }

      return aValue > bValue ? -1 : 1;
    });
  }
}
